// ============================================================
// SOUVENIR — i18n translations
// Supported: fr (French), en (English), es (Spanish), ar (Arabic)
// ============================================================

export const translations = {
  fr: {
    // ── App / Layout ──
    appName: "Souvenir",
    loading: "Chargement…",
    back: "Retour",
    save: "Enregistrer",
    cancel: "Annuler",
    confirm: "Confirmer",
    delete: "Supprimer",
    close: "Fermer",
    search: "Rechercher",
    share: "Partager",
    download: "Télécharger",
    generate: "Générer",
    regenerate: "🔄 Régénérer",
    continue: "Continuer",
    create: "Créer",
    join: "Rejoindre",
    send: "Envoyer",
    yes: "Oui",
    no: "Non",
    optional: "optionnel",
    recommended: "✨ Recommandé",
    popular: "Populaire",
    free: "Gratuit",
    error: "Une erreur est survenue",

    // ── Nav ──
    nav_home: "Accueil",
    nav_memories: "Souvenirs",
    nav_scan: "Scanner",
    nav_notifications: "Notifs",
    nav_profile: "Profil",
    nav_support: "Support",

    // ── TopBar ──
    topbar_explore: "Explorer",
    topbar_join: "Rejoindre",
    topbar_join_subtitle: "Entrez votre code d'accès",
    topbar_profile: "Profil",
    topbar_create: "Créer un événement",
    topbar_organizer: "Dashboard organisateur",
    topbar_notifications: "Notifications",
    topbar_support: "Support",

    // ── Dashboard ──
    hello: "Bonjour 👋",
    welcome: "Bienvenue",
    stat_events: "Événements",
    stat_photos: "Photos publiées",
    stat_organized: "Organisés",
    tab_all: "Tous",
    tab_active: "Actifs",
    tab_organized: "Organisés",
    tab_archived: "Archivés",
    role_organizer: "👑 Organisateur",
    plan_standard: "✨ Standard",
    plan_free: "Découverte",
    plan_plus: "⚡ Plus",
    no_events: "Aucun événement",
    no_events_tab: "Aucun événement",
    no_events_desc: "Créez ou rejoignez votre premier événement pour commencer.",
    no_events_tab_desc: "Cette section est vide pour l'instant.",
    support_center: "Centre de support",
    support_center_sub: "Tickets, facturation et aide technique",

    // ── Explore ──
    explore_title: "Rejoindre un événement",
    explore_desc: "Scannez un QR code ou entrez un code d'accès partagé par l'organisateur.",
    explore_join_btn: "Rejoindre",
    explore_create_title: "Créer votre événement",
    explore_create_desc: "Partagez un album collaboratif privé. Prêt en moins d'une minute.",
    explore_create_btn: "Commencer gratuitement",

    // ── JoinEvent ──
    scan_qr: "Scanner un QR code",
    scan_qr_desc: "Pointez votre caméra vers le code",
    or_enter_code: "ou entrez un code",
    search_btn: "Rechercher",
    join_event_btn: "Rejoindre l'événement",
    no_event_found: "Aucun événement trouvé avec ce code.",
    event_not_active: "Cet événement n'est plus actif.",
    event_full: "Cet événement a atteint sa capacité maximale.",
    participants: "Participants",
    photos: "Photos",
    status: "Statut",

    // ── CreateEvent ──
    step_type: "Type",
    step_details: "Détails",
    step_plan: "Formule",
    step_options: "Options",
    create_step1_title: "Quel type d'événement ?",
    create_step1_desc: "Choisissez pour personnaliser l'expérience.",
    create_step2_title: "Les détails",
    create_step2_desc: "Donnez vie à votre événement.",
    event_name_label: "Nom de l'événement *",
    event_name_placeholder: "Ex : Mariage de Sophie & Pierre",
    description_label: "Description",
    description_placeholder: "Quelques mots sur l'événement…",
    date_start: "Début *",
    date_end: "Fin",
    location_label: "Lieu",
    location_placeholder: "Ex : Château de Versailles",
    create_step3_title: "Choisissez votre formule",
    create_step3_desc: "Payez une seule fois, par événement.",
    create_step4_title: "Options supplémentaires",
    create_step4_desc: "Améliorez l'expérience. Toutes facultatives.",
    create_event_btn: "Créer l'événement",

    // Plans
    plan_free_name: "Free",
    plan_free_desc: "8 photos live en qualite web",
    plan_standard_name: "Standard",
    plan_standard_desc: "Pour les petits événements",
    plan_plus_name: "Plus",
    plan_plus_desc: "L'expérience complète & Live",
    per_event: "/ événement",

    // Options
    opt_gift_fund: "Cagnotte evenement",
    opt_gift_fund_desc: "Permettez aux invites de contribuer a un cadeau, une baby shower, un voyage ou un projet de groupe.",
    opt_archive: "Archivage longue durée +1 an",
    opt_archive_desc: "Conservez vos souvenirs au-delà de la période standard.",
    opt_co_host: "Co-organisateur",
    opt_co_host_desc: "Désignez quelqu'un pour gérer l'événement avec vous.",

    // ── EventPage ──
    tab_gallery: "Galerie",
    tab_bestof: "Best Of",
    tab_info: "Infos",
    tab_guests: "Invités",
    add_photos: "Ajouter des photos",
    photo_count: "photo",
    photos_count: "photos",
    reactions: "réactions",

    // ── OrganizerDashboard ──
    org_title: "Dashboard organisateur",
    org_stat_participants: "Participants",
    org_stat_photos: "Photos",
    org_stat_days: "Jours restants",
    org_stat_plan: "Plan",
    org_quick_actions: "Actions rapides",
    org_share_qr: "Partager QR",
    org_best_of: "Best Of ✨",
    org_live_wall: "Live Wall",
    org_manage: "Gestion",
    org_manage_participants: "Gérer les participants",
    org_manage_access: "Gérer les accès",
    org_manage_access_desc: "Codes, rôles, permissions",
    org_moderate: "Modérer les photos",
    org_edit_event: "Modifier l'événement",
    org_edit_event_desc: "Nom, date, couverture",
    org_contributions: "Contributions",
    org_donations: "Cagnotte evenement",
    org_donations_desc: "Suivre les contributions et versements",
    org_extend_archive: "Étendre l'archive",
    org_extend_archive_desc: "Prolonger la durée de conservation",
    org_danger: "Zone sensible",
    org_delete_photos: "Supprimer des photos",
    org_delete_photos_desc: "Modération manuelle",
    org_archive_event: "Archiver l'événement",
    org_archive_event_desc: "Fermer l'accès aux contributions",
    access_denied: "Accès refusé",

    // ── Profile ──
    profile_events: "Événements",
    profile_photos: "Photos",
    profile_organized: "Organisés",
    my_events: "Mes événements",
    my_photos: "Mes photos",
    my_reactions: "Mes réactions",
    my_reactions_sub: "Photos aimées",
    settings: "Paramètres",
    settings_sub: "Compte, notifications",
    logout: "Déconnexion",
    user_fallback: "Utilisateur",

    // ── Notifications ──
    notif_title: "Notifications",
    notif_all: "Toutes",
    notif_unread: "Non lues",
    notif_unread_count: "non lue(s)",
    notif_photos: "Photos",
    notif_events: "Événements",
    notif_reactions: "Réactions",
    notif_invitations: "Invitations",
    notif_gifts: "Cagnotte",
    notif_mark_all_read: "Tout marquer comme lu",
    notif_empty: "Aucune notification",
    notif_empty_desc: "Vous êtes à jour !",
    notif_mock_reaction: "Sophie a aimé votre photo",
    notif_mock_upload: "12 nouvelles photos ajoutées",
    notif_mock_invite: "Vous êtes invité à un événement",
    notif_mock_gift: "Nouvelle contribution à la cagnotte",
    notif_mock_archive: "Rappel d'archivage dans 7 jours",
    notif_mock_published: "Votre photo a été publiée",
    notif_mock_event1: "Mariage Sophie & Pierre",
    notif_mock_event2: "Anniversaire de Léa",
    notif_mock_event3: "Soirée d'entreprise Décembre",
    notif_mock_event4: "Mariage Sophie & Pierre — 20€ reçus",
    notif_mock_event5: "Baby Shower Emma",
    notif_mock_time1: "Il y a 2 min",
    notif_mock_time2: "Il y a 1h",
    notif_mock_time3: "Il y a 3h",
    notif_mock_time4: "Hier",
    notif_mock_time5: "Il y a 2 jours",

    // ── PhotoUploadModal ──
    upload_title: "Ajouter des photos",
    upload_remaining: "photo(s) disponible(s)",
    upload_drop: "Sélectionner des photos",
    upload_drop_sub: "ou glissez-déposez ici",
    upload_caption: "Ajoutez une légende… (optionnel)",
    upload_btn: "Publier",
    upload_progress: "Envoi en cours…",
    upload_moderating: "Analyse du contenu en cours…",

    // ── BestOfGeneratorModal ──
    bestof_title: "Générer le Best Of",
    bestof_style_label: "Style du diaporama",
    bestof_style_elegant: "Élégant",
    bestof_style_elegant_desc: "Poétique et raffiné",
    bestof_style_fun: "Fun",
    bestof_style_fun_desc: "Joyeux et dynamique",
    bestof_style_emotional: "Émouvant",
    bestof_style_emotional_desc: "Chaleureux et nostalgique",
    bestof_limit_label: "Nombre de photos",
    bestof_how_title: "Comment ça fonctionne",
    bestof_how1: "Les photos sont classées par score de réactions ❤️×3 + 😂×2 + 😮×1",
    bestof_how2: "L'IA génère des légendes narratives pour chaque photo",
    bestof_how3: "Le diaporama s'affiche directement sur votre écran",
    bestof_generate_btn: "Générer le Best Of",
    bestof_analyzing: "Analyse en cours…",
    bestof_play: "Lancer le diaporama",
    bestof_download: "Télécharger les photos",
    bestof_avg_score: "Score moy.",
    bestof_total_reactions: "réactions",

    // ── LiveWall ──
    livewall_title: "Live Wall",
    livewall_launch: "Lancer le Live Wall",
    livewall_theme: "Choisir le thème",
    livewall_theme_elegant: "Élégant",
    livewall_theme_festive: "Festif",
    livewall_theme_minimal: "Minimal",
    livewall_moderation_title: "Modération IA activée",
    livewall_moderation_desc: "Sur Plus et Premium, la moderation IA peut publier les photos sures automatiquement. Sur Free et Standard, l'organisateur valide les photos avant affichage.",
    livewall_instructions_title: "Mode d'utilisation",
    livewall_instruction1: "Projetez cet écran sur un grand écran ou vidéoprojecteur",
    livewall_instruction2: "Les invités partagent leurs photos depuis leur téléphone",
    livewall_instruction3: "Les nouvelles photos apparaissent automatiquement",
    livewall_instruction4: "Les réactions s'affichent en temps réel sous forme d'animations",

    // ── Landing ──
    landing_nav_features: "Fonctionnalités",
    landing_nav_pricing: "Tarifs",
    landing_nav_faq: "FAQ",
    landing_nav_login: "Connexion",
    landing_nav_start: "Commencer",
    landing_hero_tag: "Galerie privée & collaborative",
    landing_hero_title1: "Capturez chaque",
    landing_hero_title2: "moment ensemble",
    landing_hero_desc: "La plateforme photo privee pour vos evenements. QR code, galerie partagee, validation Free/Standard et moderation IA sur Plus et Premium.",
    landing_hero_cta: "Créer mon événement",
    landing_hero_cta_sub: "Voir comment ça marche",
    landing_hero_stat_events: "événements créés",
    landing_hero_stat_photos: "photos partagées",
    landing_hero_stat_privacy: "100% privé",
    landing_steps_tag: "Comment ça marche",
    landing_steps_title: "Simple comme un QR code",
    landing_pricing_tag: "Tarifs",
    landing_pricing_title: "Un paiement, par événement",
    landing_pricing_desc: "Pas d'abonnement. Payez uniquement pour les événements que vous organisez.",
    landing_faq_tag: "FAQ",
    landing_faq_title: "Questions fréquentes",
    landing_cta_title: "Prêt à capturer vos souvenirs ?",
    landing_cta_desc: "Créez votre premier événement en moins d'une minute.",
    landing_cta_btn: "Commencer gratuitement",
    landing_footer_rights: "Tous droits réservés.",

    // ── Landing complet ──
    landing_nav_cta: "Créer",
    landing_hero_title1: "Vos souvenirs,",
    landing_hero_title2: "réunis.",
    landing_hero_desc: "Scannez · Partagez · Revivez. Une galerie privée pour chaque événement.",
    landing_hero_join_btn: "Rejoindre avec un QR",
    landing_hero_stat_events: "événements ce mois",
    event_type_wedding: "Mariage",
    event_type_birthday: "Anniversaire",
    event_type_graduation: "Remise diplôme",
    landing_benefits_title: "Pourquoi Souvenir ?",
    landing_benefits_sub: "Pensé pour l'émotion, pas pour le stockage.",
    landing_benefit1_title: "Accès instantané",
    landing_benefit1_desc: "Un scan suffit. Zéro friction.",
    landing_benefit2_title: "Galerie collaborative",
    landing_benefit2_desc: "Tous vos souvenirs, en temps réel.",
    landing_benefit3_title: "Réactions ensemble",
    landing_benefit3_desc: "❤️ 😂 😮 — vivez l'émotion.",
    landing_benefit4_title: "100% privé",
    landing_benefit4_desc: "Entre vous. Zéro algo, zéro pub.",
    landing_how_title: "Comment ça marche ?",
    landing_how_sub: "4 étapes pour une galerie mémorable.",
    landing_step1_title: "Créez votre événement",
    landing_step1_desc: "Type, date, lieu — en 2 minutes.",
    landing_step2_title: "Partagez le QR code",
    landing_step2_desc: "Vos invités rejoignent d'un scan.",
    landing_step3_title: "Collectez les souvenirs",
    landing_step3_desc: "La galerie se remplit en direct.",
    landing_step4_title: "Revivez chaque moment",
    landing_step4_desc: "Best Of, réactions, export HD.",
    landing_occasions_title: "Pour chaque occasion",
    landing_occasions_sub: "Des galeries adaptées à votre événement.",
    landing_pricing_secure: "Paiement sécurisé · Sans abonnement",
    landing_plan_popular: "⭐ Populaire",
    landing_plan_choose: "Choisir",
    plan_free_f1: "15 participants",
    plan_free_f2: "8 photos live / participant",
    plan_free_f3: "7 jours dès le début",
    plan_free_f4: "Qualite web + validation",
    plan_std_f1: "50 participants",
    plan_std_f2: "10 photos / pers.",
    plan_std_f3: "Validation organisateur",
    plan_std_f4: "Export ZIP & Best Of",
    plan_plus_f1: "100 participants",
    plan_plus_f2: "15 photos / pers.",
    plan_plus_f3: "Live Wall 📺",
    plan_plus_f4: "Best Of ✨",
    plan_prem_f1: "250 participants",
    plan_prem_f2: "20 photos / pers.",
    plan_prem_f3: "30 jours dès le début",
    plan_prem_f4: "Support prioritaire",
    landing_test_title: "Ils l'ont adoré",
    landing_test_sub: "Des milliers d'événements célébrés.",
    test1_event: "Mariage",
    test1_text: "Un scan, et tous les invités ajoutaient leurs photos. Magique 💜",
    test2_event: "Anniversaire 30 ans",
    test2_text: "Le Best Of m'a fait pleurer de rire. Je recommande à 1000% !",
    test3_event: "Remise de diplôme",
    test3_text: "Simple, beau, privé. Exactement ce qu'il me fallait.",
    faq1_q: "Faut-il créer un compte pour participer ?",
    faq1_a: "Non. Les invités rejoignent sans compte, juste avec le QR code ou le code d'accès.",
    faq2_q: "Combien de temps les photos sont conservées ?",
    faq2_a: "Le compteur commence le jour de début de l'événement: 7 jours en Free, puis 30 jours inclus sur Standard, Plus et Premium.",
    faq3_q: "Peut-on avoir plusieurs organisateurs ?",
    faq3_a: "Oui, vous pouvez inviter un co-organisateur avec accès au dashboard.",
    faq4_q: "Les photos sont-elles publiques ?",
    faq4_a: "Non. La galerie est privée — accessible uniquement aux participants.",
    faq5_q: "Comment fonctionne la modération des photos ?",
    faq5_a: "Sur Free et Standard, les photos restent en attente de validation organisateur. Sur Plus et Premium, la moderation IA peut publier les photos sures et retenir les contenus inhabituels.",
    landing_cta_title: "Créez votre galerie\nen 2 minutes.",
    landing_cta_desc: "Vos invités rejoignent avec un QR code. Aucune installation requise.",
    landing_cta_btn: "Commencer gratuitement",
    landing_cta_join_btn: "Rejoindre un événement",
    landing_cta_fine: "Gratuit · Sans carte bancaire · Sans abonnement",
    landing_footer_product: "Produit",
    landing_footer_legal: "Légal",
    landing_footer_create: "Créer un événement",
    landing_footer_join: "Rejoindre",
    landing_footer_pricing: "Tarifs",
    landing_footer_privacy: "Confidentialité",
    landing_footer_terms: "Conditions",
    landing_footer_faq: "FAQ",
    landing_footer_rules: "Règles de la communauté",

    // ── Nouvelles clés ──
    continue_with: "Continuer avec",
    choose_plan: "Choisir ma formule",
    dark_mode: "Mode sombre",
    enabled: "Activé",
    disabled: "Désactivé",
    event_count: "événement(s)",
    someone: "Quelqu'un",
    notif_added_photo: "a ajouté une photo",
    notif_reacted: "a réagi",
    notif_to_your_photo: "à votre photo",

    // ── Event types ──
    event_wedding: "Mariage",
    event_birthday: "Anniversaire",
    event_baby_shower: "Naissance & Enfants",
    event_graduation: "Études & Jeunesse",
    event_corporate: "Professionnel",
    event_private_party: "Soirée & Social",
    event_gala: "Gala",
    event_family: "Famille",
    event_religious: "Religieux & Communauté",
    event_culture_sport: "Culture & Sport",
    event_travel: "Voyage & Lifestyle",
    event_other: "Autre",

    // ── Reactions ──
    reaction_heart: "J'adore",
    reaction_funny: "Hilarant",
    reaction_shocked: "Wow",

    // ── Dashboard ──
    hello_greeting: "Bonjour,",
    role_organizer_short: "Organisateur",
    status_active: "Actif",
    status_archived: "Archivé",
    dash_new_event: "Nouvel événement",

    // ── EventPage ──
    event_not_found: "Événement introuvable",
    event_private_title: "Accès privé",
    event_private_desc: "Rejoignez cet événement via le code ou QR code pour y accéder.",
    event_private_btn: "Rejoindre un événement",
    // ── Modération ──
    mod_title: "Modération",
    mod_pending: "En attente",
    mod_no_flagged: "Aucune photo signalée",
    mod_all_approved: "Toutes les photos publiées ont été approuvées.",
    mod_approve: "Approuver",
    mod_reject: "Rejeter",
    mod_approved_toast: "Photo approuvée ✅",
    mod_rejected_toast: "Photo rejetée ❌",
    mod_notified: "L'auteur a été notifié.",
    // ── OrganizerDashboard ──
    org_confirm_archive: "Archiver cet événement ? Les invités ne pourront plus accéder à la galerie.",
    org_confirm_delete: "Supprimer TOUTES les photos ? Cette action est irréversible.",
    org_delete_success: "photo(s) supprimée(s)",
    org_expiry_today: "Expiration aujourd'hui !",
    org_expiry_days_msg: "Photos supprimées dans {n} jour(s)",
    org_expiry_download: "Téléchargez l'archive avant expiration",
    org_dashboard_title: "Tableau de bord",
    org_qr_share_label: "QR & Partage",
    org_members_count: "membre(s)",
    org_see_contributions: "Voir les contributions",
    org_export_title: "Export",
    org_zip_title: "Archive ZIP",
    org_photos_approved_count: "photos approuvées",
    org_delete_photos_action_desc: "Effacer tout le contenu",
    org_archive_action_desc: "Fermer l'accès aux invités",
    // ── EventCreatedBanner ──
    banner_created_title: "Événement créé !",
    banner_created_desc: "Partagez ce code pour inviter vos invités",
    access_code_label: "Code d'accès",
    banner_copied: "Copié !",
    banner_copy: "Copier",
    banner_share_title: "Rejoignez cet événement",
    banner_share_text: "Partagez vos photos sur Souvenir ! Code d'accès :",
    // ── Dashboard ──
    dash_payment_confirmed: "🎉 Paiement confirmé !",
    dash_payment_confirmed_desc: "Votre événement sera disponible dans quelques instants.",
    dash_event_created_toast: "🎉 Événement créé !",
    dash_event_created_desc: "Votre événement est prêt.",
    dash_finalizing: "Finalisation de votre événement…",
    dash_finalizing_desc: "Paiement confirmé. Votre événement apparaîtra ici dans quelques instants.",
    dash_event_arriving: "Votre événement arrive…",
    user_fallback_you: "vous",
    // ── EventPage ──
    expiry_today_msg: "Vos photos expirent aujourd'hui !",
    expiry_days_msg: "Vos photos seront supprimées dans {n} jour(s)",
    event_expired_desc: "Cet événement a expiré. Les photos ont été supprimées.",
    back_to_dashboard: "Retour au tableau de bord",
    viewer_role_desc: "Vous consultez cet événement en tant que spectateur.",

    // ── GuestLinkManager ──
    guest_links_title: "Liens invités",
    guest_links_desc: "Accès galerie sans compte requis",
    guest_link_create: "Créer",
    guest_link_new: "Nouveau lien invité",
    guest_link_label_placeholder: "Étiquette (ex : Famille, Grands-parents…)",
    guest_link_expires_event: "Expire à la fin de l'événement",
    guest_link_expires_7d: "Expire dans 7 jours",
    guest_link_expires_30d: "Expire dans 30 jours",
    guest_link_never_expires: "N'expire jamais",
    guest_link_creating: "Création…",
    guest_link_create_btn: "Créer le lien",
    guest_link_empty: "Aucun lien créé",
    guest_link_empty_desc: "Partagez la galerie sans obliger les invités à créer un compte",
    guest_link_copied: "Copié !",
    guest_link_copy: "Copier le lien",
    guest_link_expired: "Expiré",
    guest_link_expires_on: "Expire le",
    guest_link_disable: "Désactiver",
    guest_link_enable: "Activer",
    guest_link_delete_confirm: "Supprimer le lien \"{label}\" ?",
    guest_link_default_label: "Invités",

    // ── ShareModal ──
    share_modal_title: "Partager",
    share_access_code_label: "Code d'accès",
    share_copy_code: "Copier le code",
    share_copied: "Copié !",

    // ── DownloadZipButton ──
    zip_unavailable_title: "Export ZIP non disponible",
    zip_unavailable_desc: "L'export ZIP est réservé aux formules Standard, Plus et Premium.",
    zip_preparing: "Préparation du ZIP…",
    zip_download_all: "Télécharger toutes les photos",
    zip_error_default: "Échec du téléchargement",
  },

  en: {
    appName: "Souvenir",
    loading: "Loading…",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    confirm: "Confirm",
    delete: "Delete",
    close: "Close",
    search: "Search",
    share: "Share",
    download: "Download",
    generate: "Generate",
    regenerate: "🔄 Regenerate",
    continue: "Continue",
    create: "Create",
    join: "Join",
    send: "Send",
    yes: "Yes",
    no: "No",
    optional: "optional",
    recommended: "✨ Recommended",
    popular: "Popular",
    free: "Free",
    error: "Something went wrong",

    nav_home: "Home",
    nav_memories: "Memories",
    nav_scan: "Scan",
    nav_notifications: "Alerts",
    nav_profile: "Profile",
    nav_support: "Support",

    topbar_explore: "Explore",
    topbar_join: "Join",
    topbar_join_subtitle: "Enter your access code",
    topbar_profile: "Profile",
    topbar_create: "Create an event",
    topbar_organizer: "Organizer dashboard",
    topbar_notifications: "Notifications",
    topbar_support: "Support",

    hello: "Hello 👋",
    welcome: "Welcome",
    stat_events: "Events",
    stat_photos: "Photos shared",
    stat_organized: "Organized",
    tab_all: "All",
    tab_active: "Active",
    tab_organized: "Organized",
    tab_archived: "Archived",
    role_organizer: "👑 Organizer",
    plan_standard: "✨ Standard",
    plan_free: "Free",
    plan_plus: "⚡ Plus",
    no_events: "No events",
    no_events_tab: "No events",
    no_events_desc: "Create or join your first event to get started.",
    no_events_tab_desc: "This section is empty for now.",
    support_center: "Support center",
    support_center_sub: "Tickets, billing and technical help",

    explore_title: "Join an event",
    explore_desc: "Scan a QR code or enter an access code shared by the organizer.",
    explore_join_btn: "Join",
    explore_create_title: "Create your event",
    explore_create_desc: "Share a private collaborative album. Ready in under a minute.",
    explore_create_btn: "Start for free",

    scan_qr: "Scan a QR code",
    scan_qr_desc: "Point your camera at the code",
    or_enter_code: "or enter a code",
    search_btn: "Search",
    join_event_btn: "Join event",
    no_event_found: "No event found with this code.",
    event_not_active: "This event is no longer active.",
    event_full: "This event has reached its maximum capacity.",
    participants: "Participants",
    photos: "Photos",
    status: "Status",

    step_type: "Type",
    step_details: "Details",
    step_plan: "Plan",
    step_options: "Options",
    create_step1_title: "What type of event?",
    create_step1_desc: "Choose to personalize the experience.",
    create_step2_title: "The details",
    create_step2_desc: "Bring your event to life.",
    event_name_label: "Event name *",
    event_name_placeholder: "E.g.: Sophie & Pierre's Wedding",
    description_label: "Description",
    description_placeholder: "A few words about the event…",
    date_start: "Start *",
    date_end: "End",
    location_label: "Location",
    location_placeholder: "E.g.: Palace of Versailles",
    create_step3_title: "Choose your plan",
    create_step3_desc: "Pay once, per event.",
    create_step4_title: "Additional options",
    create_step4_desc: "Enhance the experience. All optional.",
    create_event_btn: "Create event",

    plan_free_name: "Free",
    plan_free_desc: "8 live web-quality photos",
    plan_standard_name: "Standard",
    plan_standard_desc: "For small events",
    plan_plus_name: "Plus",
    plan_plus_desc: "The complete & Live experience",
    per_event: "/ event",

    opt_gift_fund: "Event fund",
    opt_gift_fund_desc: "Let guests contribute to a gift, baby shower, trip, or group project.",
    opt_archive: "Long-term archiving +1 year",
    opt_archive_desc: "Keep your memories beyond the standard period.",
    opt_co_host: "Co-organizer",
    opt_co_host_desc: "Designate someone to manage the event with you.",

    tab_gallery: "Gallery",
    tab_bestof: "Best Of",
    tab_info: "Info",
    tab_guests: "Guests",
    add_photos: "Add photos",
    photo_count: "photo",
    photos_count: "photos",
    reactions: "reactions",

    org_title: "Organizer dashboard",
    org_stat_participants: "Participants",
    org_stat_photos: "Photos",
    org_stat_days: "Days remaining",
    org_stat_plan: "Plan",
    org_quick_actions: "Quick actions",
    org_share_qr: "Share QR",
    org_best_of: "Best Of ✨",
    org_live_wall: "Live Wall",
    org_manage: "Management",
    org_manage_participants: "Manage participants",
    org_manage_access: "Manage access",
    org_manage_access_desc: "Codes, roles, permissions",
    org_moderate: "Moderate photos",
    org_edit_event: "Edit event",
    org_edit_event_desc: "Name, date, cover",
    org_contributions: "Contributions",
    org_donations: "Event fund",
    org_donations_desc: "Track contributions and payouts",
    org_extend_archive: "Extend archive",
    org_extend_archive_desc: "Extend storage duration",
    org_danger: "Danger zone",
    org_delete_photos: "Delete photos",
    org_delete_photos_desc: "Manual moderation",
    org_archive_event: "Archive event",
    org_archive_event_desc: "Close access to contributions",
    access_denied: "Access denied",

    profile_events: "Events",
    profile_photos: "Photos",
    profile_organized: "Organized",
    my_events: "My events",
    my_photos: "My photos",
    my_reactions: "My reactions",
    my_reactions_sub: "Liked photos",
    settings: "Settings",
    settings_sub: "Account, notifications",
    logout: "Sign out",
    user_fallback: "User",

    notif_title: "Notifications",
    notif_all: "All",
    notif_unread: "Unread",
    notif_unread_count: "unread",
    notif_photos: "Photos",
    notif_events: "Events",
    notif_reactions: "Reactions",
    notif_invitations: "Invitations",
    notif_gifts: "Gift fund",
    notif_mark_all_read: "Mark all as read",
    notif_empty: "No notifications",
    notif_empty_desc: "You're all caught up!",
    notif_mock_reaction: "Sophie liked your photo",
    notif_mock_upload: "12 new photos added",
    notif_mock_invite: "You've been invited to an event",
    notif_mock_gift: "New contribution to the fund",
    notif_mock_archive: "Archive reminder in 7 days",
    notif_mock_published: "Your photo has been published",
    notif_mock_event1: "Sophie & Pierre's Wedding",
    notif_mock_event2: "Léa's Birthday",
    notif_mock_event3: "December Company Party",
    notif_mock_event4: "Sophie & Pierre's Wedding — €20 received",
    notif_mock_event5: "Emma's Baby Shower",
    notif_mock_time1: "2 min ago",
    notif_mock_time2: "1h ago",
    notif_mock_time3: "3h ago",
    notif_mock_time4: "Yesterday",
    notif_mock_time5: "2 days ago",

    upload_title: "Add photos",
    upload_remaining: "photo(s) remaining",
    upload_drop: "Select photos",
    upload_drop_sub: "or drag and drop here",
    upload_caption: "Add a caption… (optional)",
    upload_btn: "Publish",
    upload_progress: "Uploading…",
    upload_moderating: "Analyzing content…",

    bestof_title: "Generate Best Of",
    bestof_style_label: "Slideshow style",
    bestof_style_elegant: "Elegant",
    bestof_style_elegant_desc: "Poetic and refined",
    bestof_style_fun: "Fun",
    bestof_style_fun_desc: "Joyful and dynamic",
    bestof_style_emotional: "Emotional",
    bestof_style_emotional_desc: "Warm and nostalgic",
    bestof_limit_label: "Number of photos",
    bestof_how_title: "How it works",
    bestof_how1: "Photos are ranked by reaction score ❤️×3 + 😂×2 + 😮×1",
    bestof_how2: "AI generates narrative captions for each photo",
    bestof_how3: "The slideshow displays directly on your screen",
    bestof_generate_btn: "Generate Best Of",
    bestof_analyzing: "Analyzing…",
    bestof_play: "Launch slideshow",
    bestof_download: "Download photos",
    bestof_avg_score: "Avg. score",
    bestof_total_reactions: "reactions",

    livewall_title: "Live Wall",
    livewall_launch: "Launch Live Wall",
    livewall_theme: "Choose theme",
    livewall_theme_elegant: "Elegant",
    livewall_theme_festive: "Festive",
    livewall_theme_minimal: "Minimal",
    livewall_moderation_title: "AI moderation enabled",
    livewall_moderation_desc: "On Plus and Premium, AI moderation can publish safe photos automatically. On Free and Standard, the organizer reviews photos before display.",
    livewall_instructions_title: "How to use",
    livewall_instruction1: "Project this screen on a large display or projector",
    livewall_instruction2: "Guests share their photos from their phones",
    livewall_instruction3: "New photos appear automatically",
    livewall_instruction4: "Reactions display in real time as animations",

    landing_nav_features: "Features",
    landing_nav_pricing: "Pricing",
    landing_nav_faq: "FAQ",
    landing_nav_login: "Sign in",
    landing_nav_start: "Get started",
    landing_hero_tag: "Private & collaborative gallery",
    landing_hero_title1: "Capture every",
    landing_hero_title2: "moment together",
    landing_hero_desc: "The private photo platform for your events. QR code, shared gallery, Free/Standard review, and AI moderation on Plus and Premium.",
    landing_hero_cta: "Create my event",
    landing_hero_cta_sub: "See how it works",
    landing_hero_stat_events: "events created",
    landing_hero_stat_photos: "photos shared",
    landing_hero_stat_privacy: "100% private",
    landing_steps_tag: "How it works",
    landing_steps_title: "As simple as a QR code",
    landing_pricing_tag: "Pricing",
    landing_pricing_title: "One payment, per event",
    landing_pricing_desc: "No subscription. Pay only for the events you organize.",
    landing_faq_tag: "FAQ",
    landing_faq_title: "Frequently asked questions",
    landing_cta_title: "Ready to capture your memories?",
    landing_cta_desc: "Create your first event in under a minute.",
    landing_cta_btn: "Start for free",
    landing_footer_rights: "All rights reserved.",

    // ── Landing complet ──
    landing_nav_cta: "Create",
    landing_hero_title1: "Your memories,",
    landing_hero_title2: "together.",
    landing_hero_desc: "Scan · Share · Relive. A private gallery for every event.",
    landing_hero_join_btn: "Join with a QR",
    landing_hero_stat_events: "events this month",
    event_type_wedding: "Wedding",
    event_type_birthday: "Birthday",
    event_type_graduation: "Graduation",
    landing_benefits_title: "Why Souvenir?",
    landing_benefits_sub: "Built for emotion, not storage.",
    landing_benefit1_title: "Instant access",
    landing_benefit1_desc: "One scan is all it takes.",
    landing_benefit2_title: "Collaborative gallery",
    landing_benefit2_desc: "All your memories, in real time.",
    landing_benefit3_title: "React together",
    landing_benefit3_desc: "❤️ 😂 😮 — feel the emotion.",
    landing_benefit4_title: "100% private",
    landing_benefit4_desc: "Just you. Zero algorithm, zero ads.",
    landing_how_title: "How does it work?",
    landing_how_sub: "4 steps for a memorable gallery.",
    landing_step1_title: "Create your event",
    landing_step1_desc: "Type, date, location — in 2 minutes.",
    landing_step2_title: "Share the QR code",
    landing_step2_desc: "Guests join with one scan.",
    landing_step3_title: "Collect memories",
    landing_step3_desc: "The gallery fills up live.",
    landing_step4_title: "Relive every moment",
    landing_step4_desc: "Best Of, reactions, HD export.",
    landing_occasions_title: "For every occasion",
    landing_occasions_sub: "Galleries tailored to your event.",
    landing_pricing_secure: "Secure payment · No subscription",
    landing_plan_popular: "⭐ Popular",
    landing_plan_choose: "Choose",
    plan_free_f1: "15 participants",
    plan_free_f2: "8 live photos / participant",
    plan_free_f3: "7 days from start",
    plan_free_f4: "Web quality + review",
    plan_std_f1: "50 participants",
    plan_std_f2: "10 photos / person",
    plan_std_f3: "Organizer review",
    plan_std_f4: "ZIP export & Best Of",
    plan_plus_f1: "100 participants",
    plan_plus_f2: "15 photos / person",
    plan_plus_f3: "Live Wall 📺",
    plan_plus_f4: "Best Of ✨",
    plan_prem_f1: "250 participants",
    plan_prem_f2: "20 photos / person",
    plan_prem_f3: "30 days from start",
    plan_prem_f4: "Priority support",
    landing_test_title: "They loved it",
    landing_test_sub: "Thousands of events celebrated.",
    test1_event: "Wedding",
    test1_text: "One scan, and all guests were adding photos. Magical 💜",
    test2_event: "30th Birthday",
    test2_text: "The Best Of made me cry laughing. 1000% recommend!",
    test3_event: "Graduation",
    test3_text: "Simple, beautiful, private. Exactly what I needed.",
    faq1_q: "Do guests need an account to participate?",
    faq1_a: "No. Guests join without an account, just with the QR code or access code.",
    faq2_q: "How long are photos kept?",
    faq2_a: "The countdown starts on the event start date: 7 days on Free, then 30 days included on Standard, Plus, and Premium.",
    faq3_q: "Can there be multiple organizers?",
    faq3_a: "Yes, you can invite a co-organizer with dashboard access.",
    faq4_q: "Are photos public?",
    faq4_a: "No. The gallery is private — only accessible to participants.",
    faq5_q: "How does photo moderation work?",
    faq5_a: "On Free and Standard, photos stay pending for organizer review. On Plus and Premium, AI moderation can publish safe photos and hold unusual content.",
    landing_cta_title: "Create your gallery\nin 2 minutes.",
    landing_cta_desc: "Guests join with a QR code. No installation required.",
    landing_cta_btn: "Start for free",
    landing_cta_join_btn: "Join an event",
    landing_cta_fine: "Free · No credit card · No subscription",
    landing_footer_product: "Product",
    landing_footer_legal: "Legal",
    landing_footer_create: "Create an event",
    landing_footer_join: "Join",
    landing_footer_pricing: "Pricing",
    landing_footer_privacy: "Privacy",
    landing_footer_terms: "Terms",
    landing_footer_faq: "FAQ",
    landing_footer_rules: "Community Rules",

    continue_with: "Continue with",
    choose_plan: "Choose my plan",
    dark_mode: "Dark mode",
    enabled: "Enabled",
    disabled: "Disabled",
    event_count: "event(s)",
    someone: "Someone",
    notif_added_photo: "added a photo",
    notif_reacted: "reacted",
    notif_to_your_photo: "to your photo",

    event_wedding: "Wedding",
    event_birthday: "Birthday",
    event_baby_shower: "Birth & Kids",
    event_graduation: "Education & Youth",
    event_corporate: "Professional",
    event_private_party: "Party & Social",
    event_gala: "Gala",
    event_family: "Family",
    event_religious: "Religious & Community",
    event_culture_sport: "Culture & Sport",
    event_travel: "Travel & Lifestyle",
    event_other: "Other",

    reaction_heart: "Love it",
    reaction_funny: "Hilarious",
    reaction_shocked: "Wow",

    hello_greeting: "Hello,",
    role_organizer_short: "Organizer",
    status_active: "Active",
    status_archived: "Archived",
    dash_new_event: "New event",

    event_not_found: "Event not found",
    event_private_title: "Private access",
    event_private_desc: "Join this event with the code or QR code to access it.",
    event_private_btn: "Join an event",
    // ── Moderation ──
    mod_title: "Moderation",
    mod_pending: "Pending",
    mod_no_flagged: "No flagged photos",
    mod_all_approved: "All published photos have been approved.",
    mod_approve: "Approve",
    mod_reject: "Reject",
    mod_approved_toast: "Photo approved ✅",
    mod_rejected_toast: "Photo rejected ❌",
    mod_notified: "The uploader has been notified.",
    // ── OrganizerDashboard ──
    org_confirm_archive: "Archive this event? Guests will no longer have access to the gallery.",
    org_confirm_delete: "Delete ALL photos? This action is irreversible.",
    org_delete_success: "photo(s) deleted",
    org_expiry_today: "Expiring today!",
    org_expiry_days_msg: "Photos deleted in {n} day(s)",
    org_expiry_download: "Download the archive before it expires",
    org_dashboard_title: "Dashboard",
    org_qr_share_label: "QR & Share",
    org_members_count: "member(s)",
    org_see_contributions: "View contributions",
    org_export_title: "Export",
    org_zip_title: "ZIP Archive",
    org_photos_approved_count: "approved photos",
    org_delete_photos_action_desc: "Clear all content",
    org_archive_action_desc: "Close guest access",
    // ── EventCreatedBanner ──
    banner_created_title: "Event created!",
    banner_created_desc: "Share this code to invite your guests",
    access_code_label: "Access code",
    banner_copied: "Copied!",
    banner_copy: "Copy",
    banner_share_title: "Join this event",
    banner_share_text: "Share your photos on Souvenir! Access code:",
    // ── Dashboard ──
    dash_payment_confirmed: "🎉 Payment confirmed!",
    dash_payment_confirmed_desc: "Your event will be available in a moment.",
    dash_event_created_toast: "🎉 Event created!",
    dash_event_created_desc: "Your event is ready.",
    dash_finalizing: "Finalizing your event…",
    dash_finalizing_desc: "Payment confirmed. Your event will appear here shortly.",
    dash_event_arriving: "Your event is on its way…",
    user_fallback_you: "you",
    // ── EventPage ──
    expiry_today_msg: "Your photos expire today!",
    expiry_days_msg: "Your photos will be deleted in {n} day(s)",
    event_expired_desc: "This event has expired. Photos have been deleted.",
    back_to_dashboard: "Back to dashboard",
    viewer_role_desc: "You are viewing this event as a viewer.",

    // ── GuestLinkManager ──
    guest_links_title: "Guest links",
    guest_links_desc: "Gallery access without an account",
    guest_link_create: "Create",
    guest_link_new: "New guest link",
    guest_link_label_placeholder: "Label (e.g.: Family, Grandparents…)",
    guest_link_expires_event: "Expires at event end",
    guest_link_expires_7d: "Expires in 7 days",
    guest_link_expires_30d: "Expires in 30 days",
    guest_link_never_expires: "Never expires",
    guest_link_creating: "Creating…",
    guest_link_create_btn: "Create link",
    guest_link_empty: "No links created",
    guest_link_empty_desc: "Share the gallery without requiring guests to create an account",
    guest_link_copied: "Copied!",
    guest_link_copy: "Copy link",
    guest_link_expired: "Expired",
    guest_link_expires_on: "Expires on",
    guest_link_disable: "Disable",
    guest_link_enable: "Enable",
    guest_link_delete_confirm: "Delete link \"{label}\"?",
    guest_link_default_label: "Guests",

    // ── ShareModal ──
    share_modal_title: "Share",
    share_access_code_label: "Access code",
    share_copy_code: "Copy code",
    share_copied: "Copied!",

    // ── DownloadZipButton ──
    zip_unavailable_title: "ZIP export unavailable",
    zip_unavailable_desc: "ZIP export is available on Standard, Plus and Premium plans.",
    zip_preparing: "Preparing ZIP…",
    zip_download_all: "Download all photos",
    zip_error_default: "Download failed",
  },

  es: {
    appName: "Souvenir",
    loading: "Cargando…",
    back: "Volver",
    save: "Guardar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    delete: "Eliminar",
    close: "Cerrar",
    search: "Buscar",
    share: "Compartir",
    download: "Descargar",
    generate: "Generar",
    regenerate: "🔄 Regenerar",
    continue: "Continuar",
    create: "Crear",
    join: "Unirse",
    send: "Enviar",
    yes: "Sí",
    no: "No",
    optional: "opcional",
    recommended: "✨ Recomendado",
    popular: "Popular",
    free: "Gratis",
    error: "Ha ocurrido un error",

    nav_home: "Inicio",
    nav_memories: "Recuerdos",
    nav_scan: "Escanear",
    nav_notifications: "Alertas",
    nav_profile: "Perfil",
    nav_support: "Soporte",

    topbar_explore: "Explorar",
    topbar_join: "Unirse",
    topbar_join_subtitle: "Ingresa tu código de acceso",
    topbar_profile: "Perfil",
    topbar_create: "Crear un evento",
    topbar_organizer: "Panel del organizador",
    topbar_notifications: "Notificaciones",
    topbar_support: "Soporte",

    hello: "Hola 👋",
    welcome: "Bienvenido",
    stat_events: "Eventos",
    stat_photos: "Fotos publicadas",
    stat_organized: "Organizados",
    tab_all: "Todos",
    tab_active: "Activos",
    tab_organized: "Organizados",
    tab_archived: "Archivados",
    role_organizer: "👑 Organizador",
    plan_standard: "✨ Estándar",
    plan_free: "Descubrimiento",
    plan_plus: "⚡ Plus",
    no_events: "Sin eventos",
    no_events_tab: "Sin eventos",
    no_events_desc: "Crea o únete a tu primer evento para comenzar.",
    no_events_tab_desc: "Esta sección está vacía por ahora.",
    support_center: "Centro de soporte",
    support_center_sub: "Tickets, facturacion y ayuda tecnica",

    explore_title: "Unirse a un evento",
    explore_desc: "Escanea un código QR o ingresa el código de acceso compartido por el organizador.",
    explore_join_btn: "Unirse",
    explore_create_title: "Crear tu evento",
    explore_create_desc: "Comparte un álbum colaborativo privado. Listo en menos de un minuto.",
    explore_create_btn: "Empezar gratis",

    scan_qr: "Escanear un código QR",
    scan_qr_desc: "Apunta tu cámara hacia el código",
    or_enter_code: "o ingresa un código",
    search_btn: "Buscar",
    join_event_btn: "Unirse al evento",
    no_event_found: "No se encontró ningún evento con este código.",
    event_not_active: "Este evento ya no está activo.",
    event_full: "Este evento ha alcanzado su capacidad máxima.",
    participants: "Participantes",
    photos: "Fotos",
    status: "Estado",

    step_type: "Tipo",
    step_details: "Detalles",
    step_plan: "Plan",
    step_options: "Opciones",
    create_step1_title: "¿Qué tipo de evento?",
    create_step1_desc: "Elige para personalizar la experiencia.",
    create_step2_title: "Los detalles",
    create_step2_desc: "Dale vida a tu evento.",
    event_name_label: "Nombre del evento *",
    event_name_placeholder: "Ej.: Boda de Sofía y Pedro",
    description_label: "Descripción",
    description_placeholder: "Algunas palabras sobre el evento…",
    date_start: "Inicio *",
    date_end: "Fin",
    location_label: "Lugar",
    location_placeholder: "Ej.: Palacio de Versalles",
    create_step3_title: "Elige tu plan",
    create_step3_desc: "Paga una vez, por evento.",
    create_step4_title: "Opciones adicionales",
    create_step4_desc: "Mejora la experiencia. Todas opcionales.",
    create_event_btn: "Crear evento",

    plan_free_name: "Free",
    plan_free_desc: "8 fotos en vivo en calidad web",
    plan_standard_name: "Estándar",
    plan_standard_desc: "Para eventos pequeños",
    plan_plus_name: "Plus",
    plan_plus_desc: "La experiencia completa y en vivo",
    per_event: "/ evento",

    opt_gift_fund: "Fondo del evento",
    opt_gift_fund_desc: "Permite que los invitados contribuyan a un regalo, baby shower, viaje o proyecto de grupo.",
    opt_archive: "Archivo a largo plazo +1 año",
    opt_archive_desc: "Conserva tus recuerdos más allá del período estándar.",
    opt_co_host: "Co-organizador",
    opt_co_host_desc: "Designa a alguien para gestionar el evento contigo.",

    tab_gallery: "Galería",
    tab_bestof: "Lo Mejor",
    tab_info: "Info",
    tab_guests: "Invitados",
    add_photos: "Agregar fotos",
    photo_count: "foto",
    photos_count: "fotos",
    reactions: "reacciones",

    org_title: "Panel del organizador",
    org_stat_participants: "Participantes",
    org_stat_photos: "Fotos",
    org_stat_days: "Días restantes",
    org_stat_plan: "Plan",
    org_quick_actions: "Acciones rápidas",
    org_share_qr: "Compartir QR",
    org_best_of: "Lo Mejor ✨",
    org_live_wall: "Muro en vivo",
    org_manage: "Gestión",
    org_manage_participants: "Gestionar participantes",
    org_manage_access: "Gestionar accesos",
    org_manage_access_desc: "Códigos, roles, permisos",
    org_moderate: "Moderar fotos",
    org_edit_event: "Editar evento",
    org_edit_event_desc: "Nombre, fecha, portada",
    org_contributions: "Contribuciones",
    org_donations: "Fondo del evento",
    org_donations_desc: "Seguir contribuciones y pagos",
    org_extend_archive: "Extender archivo",
    org_extend_archive_desc: "Prolongar la duración del almacenamiento",
    org_danger: "Zona peligrosa",
    org_delete_photos: "Eliminar fotos",
    org_delete_photos_desc: "Moderación manual",
    org_archive_event: "Archivar evento",
    org_archive_event_desc: "Cerrar el acceso a las contribuciones",
    access_denied: "Acceso denegado",

    profile_events: "Eventos",
    profile_photos: "Fotos",
    profile_organized: "Organizados",
    my_events: "Mis eventos",
    my_photos: "Mis fotos",
    my_reactions: "Mis reacciones",
    my_reactions_sub: "Fotos que te gustaron",
    settings: "Configuración",
    settings_sub: "Cuenta, notificaciones",
    logout: "Cerrar sesión",
    user_fallback: "Usuario",

    notif_title: "Notificaciones",
    notif_all: "Todas",
    notif_unread: "No leídas",
    notif_unread_count: "no leída(s)",
    notif_photos: "Fotos",
    notif_events: "Eventos",
    notif_reactions: "Reacciones",
    notif_invitations: "Invitaciones",
    notif_gifts: "Fondo de regalo",
    notif_mark_all_read: "Marcar todo como leído",
    notif_empty: "Sin notificaciones",
    notif_empty_desc: "¡Estás al día!",
    notif_mock_reaction: "Sophie le gustó tu foto",
    notif_mock_upload: "12 nuevas fotos agregadas",
    notif_mock_invite: "Fuiste invitado a un evento",
    notif_mock_gift: "Nueva contribución al fondo",
    notif_mock_archive: "Recordatorio de archivo en 7 días",
    notif_mock_published: "Tu foto fue publicada",
    notif_mock_event1: "Boda de Sofía y Pedro",
    notif_mock_event2: "Cumpleaños de Léa",
    notif_mock_event3: "Fiesta de empresa Diciembre",
    notif_mock_event4: "Boda de Sofía y Pedro — 20€ recibidos",
    notif_mock_event5: "Baby Shower de Emma",
    notif_mock_time1: "Hace 2 min",
    notif_mock_time2: "Hace 1h",
    notif_mock_time3: "Hace 3h",
    notif_mock_time4: "Ayer",
    notif_mock_time5: "Hace 2 días",

    upload_title: "Agregar fotos",
    upload_remaining: "foto(s) disponible(s)",
    upload_drop: "Seleccionar fotos",
    upload_drop_sub: "o arrastra y suelta aquí",
    upload_caption: "Agrega un título… (opcional)",
    upload_btn: "Publicar",
    upload_progress: "Subiendo…",
    upload_moderating: "Analizando contenido…",

    bestof_title: "Generar Lo Mejor",
    bestof_style_label: "Estilo del diaporama",
    bestof_style_elegant: "Elegante",
    bestof_style_elegant_desc: "Poético y refinado",
    bestof_style_fun: "Divertido",
    bestof_style_fun_desc: "Alegre y dinámico",
    bestof_style_emotional: "Emotivo",
    bestof_style_emotional_desc: "Cálido y nostálgico",
    bestof_limit_label: "Número de fotos",
    bestof_how_title: "Cómo funciona",
    bestof_how1: "Las fotos se clasifican por puntuación ❤️×3 + 😂×2 + 😮×1",
    bestof_how2: "La IA genera leyendas narrativas para cada foto",
    bestof_how3: "El diaporama se muestra directamente en tu pantalla",
    bestof_generate_btn: "Generar Lo Mejor",
    bestof_analyzing: "Analizando…",
    bestof_play: "Lanzar diaporama",
    bestof_download: "Descargar fotos",
    bestof_avg_score: "Punt. prom.",
    bestof_total_reactions: "reacciones",

    livewall_title: "Muro en Vivo",
    livewall_launch: "Lanzar Muro en Vivo",
    livewall_theme: "Elegir tema",
    livewall_theme_elegant: "Elegante",
    livewall_theme_festive: "Festivo",
    livewall_theme_minimal: "Minimalista",
    livewall_moderation_title: "Moderación IA activada",
    livewall_moderation_desc: "En Plus y Premium, la moderacion IA puede publicar fotos seguras automaticamente. En Free y Estandar, el organizador revisa las fotos antes de mostrarlas.",
    livewall_instructions_title: "Modo de uso",
    livewall_instruction1: "Proyecta esta pantalla en una pantalla grande o proyector",
    livewall_instruction2: "Los invitados comparten sus fotos desde su teléfono",
    livewall_instruction3: "Las nuevas fotos aparecen automáticamente",
    livewall_instruction4: "Las reacciones se muestran en tiempo real como animaciones",

    landing_nav_features: "Funciones",
    landing_nav_pricing: "Precios",
    landing_nav_faq: "FAQ",
    landing_nav_login: "Iniciar sesión",
    landing_nav_start: "Comenzar",
    landing_hero_tag: "Galería privada y colaborativa",
    landing_hero_title1: "Captura cada",
    landing_hero_title2: "momento juntos",
    landing_hero_desc: "La plataforma de fotos privada para tus eventos. Codigo QR, galeria compartida, revision Free/Estandar y moderacion IA en Plus y Premium.",
    landing_hero_cta: "Crear mi evento",
    landing_hero_cta_sub: "Ver cómo funciona",
    landing_hero_stat_events: "eventos creados",
    landing_hero_stat_photos: "fotos compartidas",
    landing_hero_stat_privacy: "100% privado",
    landing_steps_tag: "Cómo funciona",
    landing_steps_title: "Tan simple como un código QR",
    landing_pricing_tag: "Precios",
    landing_pricing_title: "Un pago, por evento",
    landing_pricing_desc: "Sin suscripción. Paga solo por los eventos que organizas.",
    landing_faq_tag: "FAQ",
    landing_faq_title: "Preguntas frecuentes",
    landing_cta_title: "¿Listo para capturar tus recuerdos?",
    landing_cta_desc: "Crea tu primer evento en menos de un minuto.",
    landing_cta_btn: "Empezar gratis",
    landing_footer_rights: "Todos los derechos reservados.",

    // ── Landing complet ──
    landing_nav_cta: "Crear",
    landing_hero_title1: "Tus recuerdos,",
    landing_hero_title2: "reunidos.",
    landing_hero_desc: "Escanea · Comparte · Revive. Una galería privada para cada evento.",
    landing_hero_join_btn: "Unirse con QR",
    landing_hero_stat_events: "eventos este mes",
    event_type_wedding: "Boda",
    event_type_birthday: "Cumpleaños",
    event_type_graduation: "Graduación",
    landing_benefits_title: "¿Por qué Souvenir?",
    landing_benefits_sub: "Pensado para las emociones, no para el almacenamiento.",
    landing_benefit1_title: "Acceso instantáneo",
    landing_benefit1_desc: "Un escaneo es suficiente.",
    landing_benefit2_title: "Galería colaborativa",
    landing_benefit2_desc: "Todos tus recuerdos, en tiempo real.",
    landing_benefit3_title: "Reaccionen juntos",
    landing_benefit3_desc: "❤️ 😂 😮 — sientan la emoción.",
    landing_benefit4_title: "100% privado",
    landing_benefit4_desc: "Solo vosotros. Sin algoritmos, sin publicidad.",
    landing_how_title: "¿Cómo funciona?",
    landing_how_sub: "4 pasos para una galería memorable.",
    landing_step1_title: "Crea tu evento",
    landing_step1_desc: "Tipo, fecha, lugar — en 2 minutos.",
    landing_step2_title: "Comparte el código QR",
    landing_step2_desc: "Los invitados se unen con un escaneo.",
    landing_step3_title: "Recopila recuerdos",
    landing_step3_desc: "La galería se llena en directo.",
    landing_step4_title: "Revive cada momento",
    landing_step4_desc: "Lo Mejor, reacciones, exportación HD.",
    landing_occasions_title: "Para cada ocasión",
    landing_occasions_sub: "Galerías adaptadas a tu evento.",
    landing_pricing_secure: "Pago seguro · Sin suscripción",
    landing_plan_popular: "⭐ Popular",
    landing_plan_choose: "Elegir",
    plan_free_f1: "15 participantes",
    plan_free_f2: "8 fotos en vivo / participante",
    plan_free_f3: "7 días desde inicio",
    plan_free_f4: "Calidad web + revision",
    plan_std_f1: "50 participantes",
    plan_std_f2: "10 fotos / persona",
    plan_std_f3: "Revision del organizador",
    plan_std_f4: "ZIP y Lo Mejor",
    plan_plus_f1: "100 participantes",
    plan_plus_f2: "15 fotos / persona",
    plan_plus_f3: "Muro en vivo 📺",
    plan_plus_f4: "Lo Mejor ✨",
    plan_prem_f1: "250 participantes",
    plan_prem_f2: "20 fotos / persona",
    plan_prem_f3: "30 días desde inicio",
    plan_prem_f4: "Soporte prioritario",
    landing_test_title: "Les encantó",
    landing_test_sub: "Miles de eventos celebrados.",
    test1_event: "Boda",
    test1_text: "Un escaneo, y todos los invitados añadían fotos. ¡Mágico! 💜",
    test2_event: "Cumpleaños 30 años",
    test2_text: "Lo Mejor me hizo llorar de risa. ¡Lo recomiendo al 1000%!",
    test3_event: "Graduación",
    test3_text: "Simple, bonito, privado. Exactamente lo que necesitaba.",
    faq1_q: "¿Los invitados necesitan cuenta para participar?",
    faq1_a: "No. Los invitados se unen sin cuenta, solo con el código QR o el código de acceso.",
    faq2_q: "¿Cuánto tiempo se guardan las fotos?",
    faq2_a: "La cuenta regresiva empieza el día de inicio del evento: 7 días en Free y 30 días incluidos en Estándar, Plus y Premium.",
    faq3_q: "¿Puede haber varios organizadores?",
    faq3_a: "Sí, puedes invitar a un co-organizador con acceso al panel.",
    faq4_q: "¿Las fotos son públicas?",
    faq4_a: "No. La galería es privada — accesible solo para los participantes.",
    faq5_q: "¿Cómo funciona la moderación de fotos?",
    faq5_a: "En Free y Estandar, las fotos esperan la revision del organizador. En Plus y Premium, la moderacion IA puede publicar fotos seguras y retener contenido inusual.",
    landing_cta_title: "Crea tu galería\nen 2 minutos.",
    landing_cta_desc: "Los invitados se unen con un código QR. Sin instalación.",
    landing_cta_btn: "Empezar gratis",
    landing_cta_join_btn: "Unirse a un evento",
    landing_cta_fine: "Gratis · Sin tarjeta · Sin suscripción",
    landing_footer_product: "Producto",
    landing_footer_legal: "Legal",
    landing_footer_create: "Crear un evento",
    landing_footer_join: "Unirse",
    landing_footer_pricing: "Precios",
    landing_footer_privacy: "Privacidad",
    landing_footer_terms: "Condiciones",
    landing_footer_faq: "FAQ",
    landing_footer_rules: "Reglas de la comunidad",

    continue_with: "Continuar con",
    choose_plan: "Elegir mi plan",
    dark_mode: "Modo oscuro",
    enabled: "Activado",
    disabled: "Desactivado",
    event_count: "evento(s)",
    someone: "Alguien",
    notif_added_photo: "agregó una foto",
    notif_reacted: "reaccionó",
    notif_to_your_photo: "a tu foto",

    event_wedding: "Boda",
    event_birthday: "Cumpleaños",
    event_baby_shower: "Nacimiento & Niños",
    event_graduation: "Estudios & Juventud",
    event_corporate: "Profesional",
    event_private_party: "Fiesta & Social",
    event_gala: "Gala",
    event_family: "Familia",
    event_religious: "Religioso & Comunidad",
    event_culture_sport: "Cultura & Deporte",
    event_travel: "Viajes y estilo de vida",
    event_other: "Otro",

    reaction_heart: "Me encanta",
    reaction_funny: "Gracioso",
    reaction_shocked: "Wow",

    hello_greeting: "Hola,",
    role_organizer_short: "Organizador",
    status_active: "Activo",
    status_archived: "Archivado",
    dash_new_event: "Nuevo evento",

    event_not_found: "Evento no encontrado",
    event_private_title: "Acceso privado",
    event_private_desc: "Únete a este evento con el código o QR para acceder.",
    event_private_btn: "Unirse a un evento",
    // ── Moderación ──
    mod_title: "Moderación",
    mod_pending: "Pendiente",
    mod_no_flagged: "Sin fotos señaladas",
    mod_all_approved: "Todas las fotos publicadas han sido aprobadas.",
    mod_approve: "Aprobar",
    mod_reject: "Rechazar",
    mod_approved_toast: "Foto aprobada ✅",
    mod_rejected_toast: "Foto rechazada ❌",
    mod_notified: "El autor ha sido notificado.",
    // ── OrganizerDashboard ──
    org_confirm_archive: "¿Archivar este evento? Los invitados ya no podrán acceder a la galería.",
    org_confirm_delete: "¿Eliminar TODAS las fotos? Esta acción es irreversible.",
    org_delete_success: "foto(s) eliminada(s)",
    org_expiry_today: "¡Expira hoy!",
    org_expiry_days_msg: "Fotos eliminadas en {n} día(s)",
    org_expiry_download: "Descarga el archivo antes de que expire",
    org_dashboard_title: "Panel",
    org_qr_share_label: "QR y Compartir",
    org_members_count: "miembro(s)",
    org_see_contributions: "Ver contribuciones",
    org_export_title: "Exportar",
    org_zip_title: "Archivo ZIP",
    org_photos_approved_count: "fotos aprobadas",
    org_delete_photos_action_desc: "Eliminar todo el contenido",
    org_archive_action_desc: "Cerrar el acceso a los invitados",
    // ── EventCreatedBanner ──
    banner_created_title: "¡Evento creado!",
    banner_created_desc: "Comparte este código para invitar a tus invitados",
    access_code_label: "Código de acceso",
    banner_copied: "¡Copiado!",
    banner_copy: "Copiar",
    banner_share_title: "Únete a este evento",
    banner_share_text: "¡Comparte tus fotos en Souvenir! Código de acceso:",
    // ── Dashboard ──
    dash_payment_confirmed: "🎉 ¡Pago confirmado!",
    dash_payment_confirmed_desc: "Tu evento estará disponible en un momento.",
    dash_event_created_toast: "🎉 ¡Evento creado!",
    dash_event_created_desc: "Tu evento está listo.",
    dash_finalizing: "Finalizando tu evento…",
    dash_finalizing_desc: "Pago confirmado. Tu evento aparecerá aquí en breve.",
    dash_event_arriving: "Tu evento está en camino…",
    user_fallback_you: "tú",
    // ── EventPage ──
    expiry_today_msg: "¡Tus fotos expiran hoy!",
    expiry_days_msg: "Tus fotos se eliminarán en {n} día(s)",
    event_expired_desc: "Este evento ha expirado. Las fotos han sido eliminadas.",
    back_to_dashboard: "Volver al panel",
    viewer_role_desc: "Estás viendo este evento como espectador.",

    // ── GuestLinkManager ──
    guest_links_title: "Enlaces de invitados",
    guest_links_desc: "Acceso a la galería sin cuenta",
    guest_link_create: "Crear",
    guest_link_new: "Nuevo enlace de invitado",
    guest_link_label_placeholder: "Etiqueta (ej.: Familia, Abuelos…)",
    guest_link_expires_event: "Expira al finalizar el evento",
    guest_link_expires_7d: "Expira en 7 días",
    guest_link_expires_30d: "Expira en 30 días",
    guest_link_never_expires: "Sin fecha de expiración",
    guest_link_creating: "Creando…",
    guest_link_create_btn: "Crear enlace",
    guest_link_empty: "Sin enlaces creados",
    guest_link_empty_desc: "Comparte la galería sin obligar a los invitados a crear una cuenta",
    guest_link_copied: "¡Copiado!",
    guest_link_copy: "Copiar enlace",
    guest_link_expired: "Expirado",
    guest_link_expires_on: "Expira el",
    guest_link_disable: "Desactivar",
    guest_link_enable: "Activar",
    guest_link_delete_confirm: "¿Eliminar el enlace \"{label}\"?",
    guest_link_default_label: "Invitados",

    // ── ShareModal ──
    share_modal_title: "Compartir",
    share_access_code_label: "Código de acceso",
    share_copy_code: "Copiar código",
    share_copied: "¡Copiado!",

    // ── DownloadZipButton ──
    zip_unavailable_title: "Exportación ZIP no disponible",
    zip_unavailable_desc: "La exportación ZIP está disponible en los planes Estándar, Plus y Premium.",
    zip_preparing: "Preparando ZIP…",
    zip_download_all: "Descargar todas las fotos",
    zip_error_default: "Error al descargar",
  },

  ar: {
    appName: "سوفنير",
    loading: "جارٍ التحميل…",
    back: "رجوع",
    save: "حفظ",
    cancel: "إلغاء",
    confirm: "تأكيد",
    delete: "حذف",
    close: "إغلاق",
    search: "بحث",
    share: "مشاركة",
    download: "تنزيل",
    generate: "توليد",
    regenerate: "🔄 إعادة التوليد",
    continue: "متابعة",
    create: "إنشاء",
    join: "انضمام",
    send: "إرسال",
    yes: "نعم",
    no: "لا",
    optional: "اختياري",
    recommended: "✨ موصى به",
    popular: "الأكثر شيوعاً",
    free: "مجاني",
    error: "حدث خطأ ما",

    nav_home: "الرئيسية",
    nav_memories: "الذكريات",
    nav_scan: "مسح",
    nav_notifications: "تنبيهات",
    nav_profile: "الملف",
    nav_support: "الدعم",

    topbar_explore: "استكشاف",
    topbar_join: "انضمام",
    topbar_join_subtitle: "أدخل رمز الدخول",
    topbar_profile: "الملف الشخصي",
    topbar_create: "إنشاء حدث",
    topbar_organizer: "لوحة المنظّم",
    topbar_notifications: "الإشعارات",
    topbar_support: "الدعم",

    hello: "مرحباً 👋",
    welcome: "أهلاً وسهلاً",
    stat_events: "الفعاليات",
    stat_photos: "الصور المنشورة",
    stat_organized: "منظَّمة",
    tab_all: "الكل",
    tab_active: "نشطة",
    tab_organized: "منظَّمة",
    tab_archived: "مؤرشفة",
    role_organizer: "👑 منظّم",
    plan_standard: "✨ قياسي",
    plan_free: "مجاني",
    plan_plus: "⚡ بلس",
    no_events: "لا توجد فعاليات",
    no_events_tab: "لا توجد فعاليات",
    no_events_desc: "أنشئ أو انضم إلى فعاليتك الأولى للبدء.",
    no_events_tab_desc: "هذا القسم فارغ حالياً.",
    support_center: "مركز الدعم",
    support_center_sub: "التذاكر والفواتير والمساعدة التقنية",

    explore_title: "الانضمام إلى فعالية",
    explore_desc: "امسح رمز QR أو أدخل رمز الدخول الذي شاركه المنظّم.",
    explore_join_btn: "انضمام",
    explore_create_title: "إنشاء فعاليتك",
    explore_create_desc: "شارك ألبومًا تعاونيًا خاصًا. جاهز في أقل من دقيقة.",
    explore_create_btn: "ابدأ مجاناً",

    scan_qr: "مسح رمز QR",
    scan_qr_desc: "وجّه كاميرتك نحو الرمز",
    or_enter_code: "أو أدخل رمزاً",
    search_btn: "بحث",
    join_event_btn: "الانضمام للفعالية",
    no_event_found: "لم يُعثر على أي فعالية بهذا الرمز.",
    event_not_active: "هذه الفعالية لم تعد نشطة.",
    event_full: "وصلت هذه الفعالية إلى حدها الأقصى.",
    participants: "المشاركون",
    photos: "الصور",
    status: "الحالة",

    step_type: "النوع",
    step_details: "التفاصيل",
    step_plan: "الخطة",
    step_options: "الخيارات",
    create_step1_title: "ما نوع الفعالية؟",
    create_step1_desc: "اختر لتخصيص التجربة.",
    create_step2_title: "التفاصيل",
    create_step2_desc: "أضف الحياة لفعاليتك.",
    event_name_label: "اسم الفعالية *",
    event_name_placeholder: "مثال: حفل زفاف سارة وأحمد",
    description_label: "الوصف",
    description_placeholder: "بعض الكلمات عن الفعالية…",
    date_start: "البداية *",
    date_end: "النهاية",
    location_label: "المكان",
    location_placeholder: "مثال: قصر فرساي",
    create_step3_title: "اختر خطتك",
    create_step3_desc: "ادفع مرة واحدة، لكل فعالية.",
    create_step4_title: "خيارات إضافية",
    create_step4_desc: "حسّن التجربة. جميعها اختيارية.",
    create_event_btn: "إنشاء الفعالية",

    plan_free_name: "Free",
    plan_free_desc: "8 صور مباشرة بجودة ويب",
    plan_standard_name: "قياسي",
    plan_standard_desc: "للفعاليات الصغيرة",
    plan_plus_name: "بلس",
    plan_plus_desc: "التجربة الكاملة والمباشرة",
    per_event: "/ فعالية",

    opt_gift_fund: "صندوق الفعالية",
    opt_gift_fund_desc: "اسمح للضيوف بالمساهمة في هدية أو مستلزمات مولود أو رحلة أو مشروع جماعي.",
    opt_archive: "أرشفة طويلة الأمد +1 سنة",
    opt_archive_desc: "احتفظ بذكرياتك بعد الفترة القياسية.",
    opt_co_host: "مشارك في التنظيم",
    opt_co_host_desc: "عيّن شخصاً لإدارة الفعالية معك.",

    tab_gallery: "المعرض",
    tab_bestof: "الأفضل",
    tab_info: "معلومات",
    tab_guests: "الضيوف",
    add_photos: "إضافة صور",
    photo_count: "صورة",
    photos_count: "صور",
    reactions: "ردود الفعل",

    org_title: "لوحة المنظّم",
    org_stat_participants: "المشاركون",
    org_stat_photos: "الصور",
    org_stat_days: "الأيام المتبقية",
    org_stat_plan: "الخطة",
    org_quick_actions: "إجراءات سريعة",
    org_share_qr: "مشاركة QR",
    org_best_of: "الأفضل ✨",
    org_live_wall: "الجدار المباشر",
    org_manage: "الإدارة",
    org_manage_participants: "إدارة المشاركين",
    org_manage_access: "إدارة الوصول",
    org_manage_access_desc: "الرموز، الأدوار، الصلاحيات",
    org_moderate: "مراجعة الصور",
    org_edit_event: "تعديل الفعالية",
    org_edit_event_desc: "الاسم، التاريخ، الغلاف",
    org_contributions: "المساهمات",
    org_donations: "صندوق الفعالية",
    org_donations_desc: "متابعة المساهمات والتحويلات",
    org_extend_archive: "تمديد الأرشيف",
    org_extend_archive_desc: "إطالة مدة الحفظ",
    org_danger: "منطقة خطرة",
    org_delete_photos: "حذف الصور",
    org_delete_photos_desc: "مراجعة يدوية",
    org_archive_event: "أرشفة الفعالية",
    org_archive_event_desc: "إغلاق الوصول إلى المساهمات",
    access_denied: "رُفض الوصول",

    profile_events: "الفعاليات",
    profile_photos: "الصور",
    profile_organized: "منظَّمة",
    my_events: "فعالياتي",
    my_photos: "صوري",
    my_reactions: "ردود فعلي",
    my_reactions_sub: "الصور المُعجَب بها",
    settings: "الإعدادات",
    settings_sub: "الحساب، الإشعارات",
    logout: "تسجيل الخروج",
    user_fallback: "مستخدم",

    notif_title: "الإشعارات",
    notif_all: "الكل",
    notif_unread: "غير مقروءة",
    notif_unread_count: "غير مقروء",
    notif_photos: "الصور",
    notif_events: "الفعاليات",
    notif_reactions: "ردود الفعل",
    notif_invitations: "الدعوات",
    notif_gifts: "صندوق الهدايا",
    notif_mark_all_read: "وضع الكل كمقروء",
    notif_empty: "لا توجد إشعارات",
    notif_empty_desc: "أنت على اطلاع تام!",
    notif_mock_reaction: "سوفي أعجبت بصورتك",
    notif_mock_upload: "تمت إضافة 12 صورة جديدة",
    notif_mock_invite: "تمت دعوتك إلى فعالية",
    notif_mock_gift: "مساهمة جديدة في الصندوق",
    notif_mock_archive: "تذكير بالأرشفة خلال 7 أيام",
    notif_mock_published: "تم نشر صورتك",
    notif_mock_event1: "زفاف سوفي وبيير",
    notif_mock_event2: "عيد ميلاد ليا",
    notif_mock_event3: "حفل شركة ديسمبر",
    notif_mock_event4: "زفاف سوفي وبيير — 20€ مستلمة",
    notif_mock_event5: "حفل استقبال مولود إيما",
    notif_mock_time1: "منذ دقيقتين",
    notif_mock_time2: "منذ ساعة",
    notif_mock_time3: "منذ 3 ساعات",
    notif_mock_time4: "أمس",
    notif_mock_time5: "منذ يومين",

    upload_title: "إضافة صور",
    upload_remaining: "صورة متاحة",
    upload_drop: "اختر الصور",
    upload_drop_sub: "أو اسحب وأفلت هنا",
    upload_caption: "أضف تعليقاً… (اختياري)",
    upload_btn: "نشر",
    upload_progress: "جارٍ الرفع…",
    upload_moderating: "جارٍ تحليل المحتوى…",

    bestof_title: "توليد الأفضل",
    bestof_style_label: "أسلوب العرض",
    bestof_style_elegant: "أنيق",
    bestof_style_elegant_desc: "شعري ورفيع",
    bestof_style_fun: "مرح",
    bestof_style_fun_desc: "بهيج وحيوي",
    bestof_style_emotional: "مؤثر",
    bestof_style_emotional_desc: "دافئ وحنيني",
    bestof_limit_label: "عدد الصور",
    bestof_how_title: "كيف يعمل",
    bestof_how1: "تُصنَّف الصور حسب درجة ردود الفعل ❤️×3 + 😂×2 + 😮×1",
    bestof_how2: "يولّد الذكاء الاصطناعي تعليقات سردية لكل صورة",
    bestof_how3: "يُعرض العرض التقديمي مباشرة على شاشتك",
    bestof_generate_btn: "توليد الأفضل",
    bestof_analyzing: "جارٍ التحليل…",
    bestof_play: "تشغيل العرض",
    bestof_download: "تنزيل الصور",
    bestof_avg_score: "متوسط الدرجات",
    bestof_total_reactions: "ردود فعل",

    livewall_title: "الجدار المباشر",
    livewall_launch: "تشغيل الجدار المباشر",
    livewall_theme: "اختر السمة",
    livewall_theme_elegant: "أنيق",
    livewall_theme_festive: "احتفالي",
    livewall_theme_minimal: "بسيط",
    livewall_moderation_title: "مراجعة الذكاء الاصطناعي مفعّلة",
    livewall_moderation_desc: "في الخطط المدفوعة، يمكن نشر الصور الآمنة تلقائياً. في Free، يراجع المنظّم الصور قبل عرضها.",
    livewall_instructions_title: "طريقة الاستخدام",
    livewall_instruction1: "اعرض هذه الشاشة على شاشة كبيرة أو جهاز عرض",
    livewall_instruction2: "يشارك الضيوف صورهم من هواتفهم",
    livewall_instruction3: "تظهر الصور الجديدة تلقائياً",
    livewall_instruction4: "تُعرض ردود الفعل في الوقت الفعلي كرسوم متحركة",

    landing_nav_features: "الميزات",
    landing_nav_pricing: "الأسعار",
    landing_nav_faq: "الأسئلة",
    landing_nav_login: "تسجيل الدخول",
    landing_nav_start: "ابدأ الآن",
    landing_hero_tag: "معرض خاص وتعاوني",
    landing_hero_title1: "التقط كل",
    landing_hero_title2: "لحظة معاً",
    landing_hero_desc: "منصة الصور الخاصة لفعالياتك. رمز QR، معرض مشترك، مراجعة في Free وذكاء اصطناعي في الخطط المدفوعة.",
    landing_hero_cta: "إنشاء فعاليتي",
    landing_hero_cta_sub: "اكتشف كيف يعمل",
    landing_hero_stat_events: "فعالية مُنشأة",
    landing_hero_stat_photos: "صورة مشتركة",
    landing_hero_stat_privacy: "خصوصية 100%",
    landing_steps_tag: "كيف يعمل",
    landing_steps_title: "بسيط كرمز QR",
    landing_pricing_tag: "الأسعار",
    landing_pricing_title: "دفعة واحدة، لكل فعالية",
    landing_pricing_desc: "بدون اشتراك. ادفع فقط للفعاليات التي تنظمها.",
    landing_faq_tag: "الأسئلة الشائعة",
    landing_faq_title: "أسئلة متكررة",
    landing_cta_title: "هل أنت مستعد لالتقاط ذكرياتك؟",
    landing_cta_desc: "أنشئ فعاليتك الأولى في أقل من دقيقة.",
    landing_cta_btn: "ابدأ مجاناً",
    landing_footer_rights: "جميع الحقوق محفوظة.",

    // ── Landing complet ──
    landing_nav_cta: "إنشاء",
    landing_hero_title1: "ذكرياتك،",
    landing_hero_title2: "مجتمعة.",
    landing_hero_desc: "امسح · شارك · أعِد العيش. معرض خاص لكل فعالية.",
    landing_hero_join_btn: "انضم برمز QR",
    landing_hero_stat_events: "فعالية هذا الشهر",
    event_type_wedding: "زفاف",
    event_type_birthday: "عيد ميلاد",
    event_type_graduation: "تخرج",
    landing_benefits_title: "لماذا سوفنير؟",
    landing_benefits_sub: "مصمَّم للمشاعر، لا للتخزين.",
    landing_benefit1_title: "وصول فوري",
    landing_benefit1_desc: "مسح واحد يكفي.",
    landing_benefit2_title: "معرض تعاوني",
    landing_benefit2_desc: "كل ذكرياتك، في الوقت الفعلي.",
    landing_benefit3_title: "ردود فعل مشتركة",
    landing_benefit3_desc: "❤️ 😂 😮 — عيشوا اللحظة.",
    landing_benefit4_title: "خصوصية 100%",
    landing_benefit4_desc: "بينكم فقط. بلا خوارزميات، بلا إعلانات.",
    landing_how_title: "كيف يعمل؟",
    landing_how_sub: "4 خطوات لمعرض لا يُنسى.",
    landing_step1_title: "أنشئ فعاليتك",
    landing_step1_desc: "النوع، التاريخ، المكان — في دقيقتين.",
    landing_step2_title: "شارك رمز QR",
    landing_step2_desc: "يلتحق الضيوف بمسح واحد.",
    landing_step3_title: "اجمع الذكريات",
    landing_step3_desc: "يمتلئ المعرض مباشرةً.",
    landing_step4_title: "أعِد عيش كل لحظة",
    landing_step4_desc: "الأفضل، ردود الفعل، تصدير HD.",
    landing_occasions_title: "لكل مناسبة",
    landing_occasions_sub: "معارض مُكيَّفة لفعاليتك.",
    landing_pricing_secure: "دفع آمن · بدون اشتراك",
    landing_plan_popular: "⭐ الأكثر شيوعاً",
    landing_plan_choose: "اختر",
    plan_free_f1: "15 مشاركاً",
    plan_free_f2: "8 صور مباشرة / مشارك",
    plan_free_f3: "7 أيام من البداية",
    plan_free_f4: "جودة ويب + مراجعة",
    plan_std_f1: "50 مشاركاً",
    plan_std_f2: "10 صور / شخص",
    plan_std_f3: "مراجعة المنظم",
    plan_std_f4: "ZIP وأفضل الصور",
    plan_plus_f1: "100 مشارك",
    plan_plus_f2: "15 صورة / شخص",
    plan_plus_f3: "الجدار المباشر 📺",
    plan_plus_f4: "الأفضل ✨",
    plan_prem_f1: "250 مشارك",
    plan_prem_f2: "20 صورة / شخص",
    plan_prem_f3: "30 يوماً من البداية",
    plan_prem_f4: "دعم ذو أولوية",
    landing_test_title: "أحبوه",
    landing_test_sub: "آلاف الفعاليات احتُفل بها.",
    test1_event: "زفاف",
    test1_text: "مسح واحد، وكان جميع الضيوف يضيفون صورهم. سحر! 💜",
    test2_event: "عيد ميلاد الـ 30",
    test2_text: "جعلني الأفضل أبكي من الضحك. أوصي به بنسبة 1000%!",
    test3_event: "تخرج",
    test3_text: "بسيط، جميل، خاص. بالضبط ما كنت أحتاجه.",
    faq1_q: "هل يحتاج الضيوف إلى حساب للمشاركة؟",
    faq1_a: "لا. يلتحق الضيوف بدون حساب، فقط برمز QR أو رمز الدخول.",
    faq2_q: "كم من الوقت تُحفَظ الصور؟",
    faq2_a: "يبدأ العد من تاريخ بداية الفعالية: 7 أيام في Free و30 يوماً مضمّنة في Standard وPlus وPremium.",
    faq3_q: "هل يمكن أن يكون هناك عدة منظمين؟",
    faq3_a: "نعم، يمكنك دعوة مشارك في التنظيم مع وصول للوحة التحكم.",
    faq4_q: "هل الصور عامة؟",
    faq4_a: "لا. المعرض خاص — لا يمكن الوصول إليه إلا للمشاركين.",
    faq5_q: "كيف تعمل مراجعة الصور؟",
    faq5_a: "في Free، تُرفع الصور بجودة ويب وتنتظر مراجعة المنظّم. في الخطط المدفوعة، يمكن للمراجعة بالذكاء الاصطناعي نشر الصور الآمنة تلقائياً وترك المحتوى غير الاعتيادي للمراجعة.",
    landing_cta_title: "أنشئ معرضك\nفي دقيقتين.",
    landing_cta_desc: "يلتحق الضيوف برمز QR. لا تثبيت مطلوب.",
    landing_cta_btn: "ابدأ مجاناً",
    landing_cta_join_btn: "الانضمام لفعالية",
    landing_cta_fine: "مجاني · بلا بطاقة · بلا اشتراك",
    landing_footer_product: "المنتج",
    landing_footer_legal: "القانوني",
    landing_footer_create: "إنشاء فعالية",
    landing_footer_join: "انضمام",
    landing_footer_pricing: "الأسعار",
    landing_footer_privacy: "الخصوصية",
    landing_footer_terms: "الشروط",
    landing_footer_faq: "الأسئلة الشائعة",
    landing_footer_rules: "قواعد المجتمع",

    continue_with: "المتابعة مع",
    choose_plan: "اختر خطتي",
    dark_mode: "الوضع المظلم",
    enabled: "مفعّل",
    disabled: "معطّل",
    event_count: "فعالية",
    someone: "شخص ما",
    notif_added_photo: "أضاف صورة",
    notif_reacted: "تفاعل",
    notif_to_your_photo: "مع صورتك",

    event_wedding: "زفاف",
    event_birthday: "عيد ميلاد",
    event_baby_shower: "مولود وأطفال",
    event_graduation: "تعليم وشباب",
    event_corporate: "مهني",
    event_private_party: "حفلة واجتماع",
    event_gala: "حفل غالا",
    event_family: "عائلة",
    event_religious: "ديني ومجتمعي",
    event_culture_sport: "ثقافة ورياضة",
    event_travel: "سفر ونمط حياة",
    event_other: "أخرى",

    reaction_heart: "أحببته",
    reaction_funny: "مضحك",
    reaction_shocked: "رائع",

    hello_greeting: "مرحباً،",
    role_organizer_short: "منظّم",
    status_active: "نشط",
    status_archived: "مؤرشف",
    dash_new_event: "فعالية جديدة",

    event_not_found: "الفعالية غير موجودة",
    event_private_title: "وصول خاص",
    event_private_desc: "انضم إلى هذه الفعالية بالرمز أو رمز QR للوصول إليها.",
    event_private_btn: "الانضمام لفعالية",
    // ── المراجعة ──
    mod_title: "المراجعة",
    mod_pending: "قيد الانتظار",
    mod_no_flagged: "لا توجد صور مُبلَّغ عنها",
    mod_all_approved: "جميع الصور المنشورة تمت الموافقة عليها.",
    mod_approve: "موافقة",
    mod_reject: "رفض",
    mod_approved_toast: "تمت الموافقة على الصورة ✅",
    mod_rejected_toast: "تم رفض الصورة ❌",
    mod_notified: "تم إشعار المرسِل.",
    // ── OrganizerDashboard ──
    org_confirm_archive: "هل تريد أرشفة هذه الفعالية؟ لن يتمكن الضيوف من الوصول إلى المعرض بعد الآن.",
    org_confirm_delete: "حذف كل الصور؟ هذا الإجراء لا يمكن التراجع عنه.",
    org_delete_success: "صورة محذوفة",
    org_expiry_today: "تنتهي الصلاحية اليوم!",
    org_expiry_days_msg: "ستُحذف الصور خلال {n} يوم",
    org_expiry_download: "نزّل الأرشيف قبل انتهاء الصلاحية",
    org_dashboard_title: "لوحة التحكم",
    org_qr_share_label: "QR والمشاركة",
    org_members_count: "عضو",
    org_see_contributions: "عرض المساهمات",
    org_export_title: "تصدير",
    org_zip_title: "أرشيف ZIP",
    org_photos_approved_count: "صور معتمدة",
    org_delete_photos_action_desc: "مسح كل المحتوى",
    org_archive_action_desc: "إغلاق وصول الضيوف",
    // ── EventCreatedBanner ──
    banner_created_title: "تم إنشاء الفعالية!",
    banner_created_desc: "شارك هذا الرمز لدعوة ضيوفك",
    access_code_label: "رمز الوصول",
    banner_copied: "تم النسخ!",
    banner_copy: "نسخ",
    banner_share_title: "انضم إلى هذه الفعالية",
    banner_share_text: "شارك صورك على سوفنير! رمز الوصول:",
    // ── Dashboard ──
    dash_payment_confirmed: "🎉 تم تأكيد الدفع!",
    dash_payment_confirmed_desc: "ستكون فعاليتك متاحة خلال لحظات.",
    dash_event_created_toast: "🎉 تم إنشاء الفعالية!",
    dash_event_created_desc: "فعاليتك جاهزة.",
    dash_finalizing: "جارٍ إنهاء فعاليتك…",
    dash_finalizing_desc: "تم تأكيد الدفع. ستظهر فعاليتك هنا خلال لحظات.",
    dash_event_arriving: "فعاليتك في الطريق…",
    user_fallback_you: "أنت",
    // ── EventPage ──
    expiry_today_msg: "صورك تنتهي اليوم!",
    expiry_days_msg: "ستُحذف صورك خلال {n} يوم",
    event_expired_desc: "انتهت صلاحية هذه الفعالية. تم حذف الصور.",
    back_to_dashboard: "العودة للوحة التحكم",
    viewer_role_desc: "أنت تشاهد هذه الفعالية كمشاهد.",

    // ── GuestLinkManager ──
    guest_links_title: "روابط الضيوف",
    guest_links_desc: "الوصول للمعرض بدون حساب",
    guest_link_create: "إنشاء",
    guest_link_new: "رابط ضيف جديد",
    guest_link_label_placeholder: "تسمية (مثال: العائلة، الأجداد…)",
    guest_link_expires_event: "ينتهي مع نهاية الفعالية",
    guest_link_expires_7d: "ينتهي خلال 7 أيام",
    guest_link_expires_30d: "ينتهي خلال 30 يوماً",
    guest_link_never_expires: "لا ينتهي أبداً",
    guest_link_creating: "جارٍ الإنشاء…",
    guest_link_create_btn: "إنشاء الرابط",
    guest_link_empty: "لا توجد روابط",
    guest_link_empty_desc: "شارك المعرض دون إلزام الضيوف بإنشاء حساب",
    guest_link_copied: "تم النسخ!",
    guest_link_copy: "نسخ الرابط",
    guest_link_expired: "منتهي",
    guest_link_expires_on: "ينتهي في",
    guest_link_disable: "تعطيل",
    guest_link_enable: "تفعيل",
    guest_link_delete_confirm: "حذف الرابط \"{label}\"؟",
    guest_link_default_label: "الضيوف",

    // ── ShareModal ──
    share_modal_title: "مشاركة",
    share_access_code_label: "رمز الوصول",
    share_copy_code: "نسخ الرمز",
    share_copied: "تم النسخ!",

    // ── DownloadZipButton ──
    zip_unavailable_title: "تصدير ZIP غير متاح",
    zip_unavailable_desc: "تصدير ZIP متاح في خطط القياسي والبلس والبريميوم.",
    zip_preparing: "جارٍ تحضير ZIP…",
    zip_download_all: "تنزيل جميع الصور",
    zip_error_default: "فشل التنزيل",
  },
};

export const RTL_LANGUAGES = ["ar"];
export const LANGUAGES = [
  { code: "fr", label: "Français", shortLabel: "FR" },
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "es", label: "Español", shortLabel: "ES" },
  { code: "ar", label: "العربية", shortLabel: "AR" },
];
